import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/allocation/_layout/settings")({})
